import React, { useMemo, useCallback } from 'react'
import PropTypes from 'prop-types'

import AccordionContext from './AccordionContext'
import useControlled from '../../utils/useControlled'

const Accordion = (props) => {
	const { children, defaultExpanded = false, disabled = false, expanded: expandedProp, onChange } = props

	const [expanded, setExpandedState] = useControlled({
		controlled: expandedProp,
		default: Boolean(defaultExpanded)
	})

	const handleChange = useCallback(
		(event) => {
			setExpandedState(!expanded)
			if (onChange) {
				onChange(event, !expanded)
			}
		},
		[expanded, onChange, setExpandedState]
	)

	const context = useMemo(() => {
		return {
			expanded,
			defaultExpanded,
			disabled,
			toggle: handleChange,
			isControlled: expandedProp ? true : false
		}
	}, [expanded, disabled, handleChange])

	return <AccordionContext.Provider value={context}>{children}</AccordionContext.Provider>
}

export default Accordion

Accordion.propTypes = {
	/**
	 * The content of the component.
	 */
	children: PropTypes.node,
	/**
	 * @ignore
	 */
	className: PropTypes.string,
	/**
	 * If `true`, expands the accordion by default.
	 * @default false
	 */
	defaultExpanded: PropTypes.bool,
	/**
	 * If `true`, the component is disabled.
	 * @default false
	 */
	disabled: PropTypes.bool,
	/**
	 * If `true`, it removes the margin between two expanded accordion items and the increase of height.
	 * @default false
	 */
	expanded: PropTypes.bool,
	/**
	 * Callback fired when the expand/collapse state is changed.
	 *
	 * @param {object} event The event source of the callback. **Warning**: This is a generic event not a change event.
	 * @param {boolean} expanded The `expanded` state of the accordion.
	 */
	onChange: PropTypes.func
}
